import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {PATTERN_SWITCH} from 'session/constants.js';

class PatternSwitchEvent extends SessionEvent {
    constructor(patternNumber) {
        super();
        this.patternNumber = patternNumber;
    }

    getValue() {
        return this.patternNumber;
    }

    isSkippable() {
       return false;
    }

    isDeterministic() {
        return true;
    }

    executeEvent(sequencerEngine) {
        sequencerEngine.switchToPatternHelper(this.patternNumber);
    }

    getJson() {
        return {
            ... super.getJson(),
            patternNumber: this.patternNumber,
        };
    }

    getCopy(sequencerEngine) {
        let pattern = new PatternSwitchEvent();
        pattern.fromJson(this.getJson(), sequencerEngine);
        return pattern;
    }

    getType() {
        return PATTERN_SWITCH;
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.loadSubSequence(json, sequencerEngine);
        this.patternNumber = json.patternNumber;
        return this;
    }
}

export default PatternSwitchEvent;
